import { combineReducers } from "redux";
import { authReducer as auth } from "#root/redux/auth/reducer";

const rootReducer = combineReducers({
  auth,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
